<div class="ee-field-flex">
  <div class="title" *ngIf="options.title || options.titleIcon">
    <ng-container *ngIf="options.title">
        {{ options.title }}
    </ng-container>
    <ng-container *ngIf="options.titleIcon">
      <mat-icon class="mat-icon-{{options.titleIcon}}">{{ options.titleIcon }}</mat-icon>
    </ng-container>
  </div>

  <mat-form-field class="xm-link-field">
    <mat-label>{{options.label | translate}}</mat-label>
    <input matInput
           class="abs"
           [type]="type"
           [step]="options.precision"
           [placeholder]="options.placeholder | translate"
           [formControl]="formControl"
           (change)="onValueChanged($event)">

    <span *ngIf="options.prefix" matPrefix class="suff-inner prefix">{{ options.prefix | translate }}</span>
    <span *ngIf="options.postfix || options.actionIcon" matSuffix class="suff-inner postfix">
          <ng-container *ngIf="options.postfix">
                  {{ options.postfix | translate }}
          </ng-container>
          <ng-container *ngIf="options.titleIcon">
                  <mat-icon class="mat-icon-{{options.actionIcon}}">{{ options.actionIcon }}</mat-icon>
          </ng-container>
    </span>

    <mat-error *ngIf="formControl.hasError('required')">
      {{ options.validationMessages?.required | translate }}
    </mat-error>
    <mat-error *ngIf="formControl.errors?.min">
      {{ options.validationMessages?.minValue | translate }}
    </mat-error>
    <mat-error *ngIf="formControl.errors?.max">
      {{ options.validationMessages?.maxValue | translate }}
    </mat-error>
    <mat-hint>{{ options.hint | translate }}&nbsp;</mat-hint>

  </mat-form-field>

</div>


